module.exports = __webpack_public_path__ + "static/story5-small-thumbnails-100x100-3beb340b1d04002daa28219c32807c69.jpg";